(() => {
  const video = document.querySelector('.hero-video-frame video');
  if (!video) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  let inView = true;
  const update = () => {
    if (document.hidden || reduce.matches || !inView) video.pause();
    else { const play = video.play(); if (play) play.catch(() => {}); }
  };
  if ('IntersectionObserver' in window) new IntersectionObserver(entries => {
    inView = entries[0].isIntersecting; update();
  }).observe(video);
  document.addEventListener('visibilitychange', update);
  reduce.addEventListener('change', update);
  update();
})();
